import Commons from '../../../Services/Common/Common';

export const M_EIC_BASIC_Schema = {
  fields: {
    qty: { initial: '', label: '수량', required: 'Y' },
    remark: { initial: '', label: '비고' },
  },

  mapper: {
    /** 인력 조회 GetEicBasicR1 */
    search2: {
      CustCd: (context) => Commons.EncryptAES(context.custCd ?? '') || '',
    },
    /** 보호구등록 조회 GetPpeBasic01R1 (SP_PPE_BASIC_03_R1) */
    search3: {
      CustCd: (context) => Commons.EncryptAES(context.custCd ?? '') || '',
    },
    /** 근로자별 보호구 저장 SaveEicBasicU1 (SP_EQUIP_ISSUE_U1) */
    save1: {
      ErCd: (row) => Commons.EncryptAES(row.erCd?.toString() ?? '') || '',
      CustCd: (row) => Commons.EncryptAES(row.custCd ?? '') || '',
      ToUserId: (row) => Commons.EncryptAES(row.toUserId ?? '') || '',
      Qty: (row) =>
        Commons.EncryptAES(String(row.qty) ?? '') || '',
      Reason: (row) => Commons.EncryptAES(row.reason ?? '') || '',
      IssuSign: (row) => Commons.EncryptAES('N') || '',
      IssuSignPath: (row) => Commons.EncryptAES('') || '',
      Remark: (row) => Commons.EncryptAES(row.remark ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
